export class SearchForNimmstaDevicesAction {
    constructor() {
        this.name = 'SearchForNimmstaDevices';
        this.isDeviceAction = false;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2VhcmNoRm9yTmltbXN0YURldmljZXNBY3Rpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL21vZGVscy9hY3Rpb25zL1NlYXJjaEZvck5pbW1zdGFEZXZpY2VzQWN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFBLE1BQU0sT0FBTyw2QkFBNkI7SUFBMUM7UUFDa0IsU0FBSSxHQUFHLHlCQUF5QixDQUFDO1FBQ2pDLG1CQUFjLEdBQUcsS0FBSyxDQUFDO0lBQ3pDLENBQUM7Q0FBQSJ9